import { useState } from 'react'
import './Auth.scss'
import image from '../../assets/images/4.jpeg'
import FormLoader from '../../components/loader/FormLoader'
import { Link } from 'react-router-dom'
import { useGlobalContext } from '../../utils/Context'
import { postNo } from '../../utils/Api'

function CreateAccount() {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)

  function handleSubmit(data: any) {
    setLoading(true)
    postNo('onboarding-requests/create', data)
      .then((res) => {
        if (res.status === 201) {
          notify('success', res.message)
          setLoading(false)
          window.location.replace('/login')
        } else {
          notify('error', res.message)
          setLoading(false)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <div className='auth flex'>
      <div className='left'>
        <img src={image} alt='delivery man image' />
      </div>
      <div className='right flex '>
        <div className='wrap'>
          <div className='top'>
            <h1>Create Account</h1>
            <p>Create an account and get started using our APIs</p>
          </div>
          <form
            onSubmit={(e: any) => {
              e.preventDefault()
              const firstname = e.target.firstname.value
              const lastname = e.target.lastname.value
              const website = e.target.website.value
              const email = e.target.email.value
              const phonenumber = e.target.phonenumber.value
              const companyName = e.target.companyName.value
              const companyDescription = e.target.companyDescription.value
              const intent = e.target.intent.value

              if (
                !firstname ||
                !lastname ||
                !website ||
                !email ||
                !phonenumber ||
                !companyName ||
                !companyDescription ||
                !intent
              ) {
                notify('warn', 'Please fill in all compulsory fields')
                return
              }

              // Handle form submission
              handleSubmit({
                firstname,
                lastname,
                website,
                email: email.toLowerCase(),
                phonenumber,
                company_name: companyName,
                company_description: companyDescription,
                intent,
              })
            }}
          >
            <div className='card'>
              <p>
                Company Name <span className='color-red'>*</span>
              </p>
              <input type='text' name='companyName' />
            </div>
            <div className='flex gap-16'>
              <div className='card'>
                <p>
                  Rep First Name <span className='color-red'>*</span>
                </p>
                <input type='text' name='firstname' />
              </div>
              <div className='card'>
                <p>
                  Rep Last Name <span className='color-red'>*</span>
                </p>
                <input type='text' name='lastname' />
              </div>
            </div>
            <div className='card'>
              <p>
                Company Email <span className='color-red'>*</span>
              </p>
              <input type='email' name='email' />
            </div>
            <div className='flex gap-16'>
              <div className='card'>
                <p>
                  Company Phone Number <span className='color-red'>*</span>
                </p>
                <input type='tel' name='phonenumber' />
              </div>
              <div className='card'>
                <p>
                  Website <span className='color-red'>*</span>
                </p>
                <input type='url' name='website' />
              </div>
            </div>
            <div className='card'>
              <p>
                Company Description <span className='color-red'>*</span>
              </p>
              <textarea name='companyDescription' id='' rows={10}></textarea>
            </div>
            <div className='card'>
              <p>
                Intent <span className='color-red'>*</span>
              </p>
              <textarea name='intent' id='' rows={10}></textarea>
            </div>

            {/* <div className='card'>
                <p>Referral code</p>
                <input type='text' name='friend' />
              </div> */}
            <div className='card btn'>
              {loading ? (
                <FormLoader position='center' />
              ) : (
                <button type='submit'>Sign Up</button>
              )}
            </div>
            <div className='card forgot '>
              <Link to='/login'>
                <p>Login</p>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default CreateAccount
